import CasinoLights from './CasinoLights';
import RainbowDemoButton from './DemoButton';
import RainbowButtonOldMethod from './OldMethod';

function RainbowButtonEmbeds({ variant }: { variant: string }) {
  if (variant === 'casino-lights') {
    return <CasinoLights />;
  } else if (variant === 'demo-button') {
    return <RainbowDemoButton />;
  } else if (variant === 'old-method') {
    return <RainbowButtonOldMethod />;
  } else {
    throw new Error('Unrecognized variant: ' + variant);
  }
}

export default RainbowButtonEmbeds;
